import React from 'react'
import Autosuggest from 'react-autosuggest'
import axios from 'axios'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import './styles.css';
  
async function getMatchingLanguages(searchText) {
    const inputValue = searchText.trim().toLowerCase()
    const inputLength = inputValue.length
    if (inputLength <= 2) {
        // don't trigger API unless there are three characters in input
        return []
    }

    const result = await axios(`/api/job_titles?match=${inputValue}&perPage=20&page=1&columns=id,job_title,job_function`)

    const titles = get(result, 'data.data.data', [])

    const formatedTitles = titles.map(title => {
        return {
            id: title.id,
            jobTitle: title.job_title,
            jobFunction: title.job_function,
        }
    })
    return formatedTitles
}



/* --------------- */
/*    Component    */
/* --------------- */

function getSuggestionValue(suggestion) {
    return suggestion.jobTitle
}

function renderSuggestion(suggestion) {
    return (
        <>
            <div className='jobTitle'>{suggestion.jobTitle}</div>
            <div className='jobFunction'>{suggestion.jobFunction}</div>
        </>
    )
}

class TitleSelector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            value: '',
            suggestions: [],
            isLoading: false,
        }

        this.lastRequestId = null
    }

    async loadSuggestions(value) {
        // Cancel the previous request
        // if (this.lastRequestId !== null) {
        //   clearTimeout(this.lastRequestId);
        // }

        this.setState({
            isLoading: true,
        })
        const data = await getMatchingLanguages(value)

        this.setState({
            isLoading: false,
            suggestions: data,
        })

        // Fake request
        // this.lastRequestId = setTimeout(() => {
        //   this.setState({
        //     isLoading: false,
        //     suggestions:
        //   });
        // }, 1000);
    }

    onChange = (event, obj) => {
        this.setState({
            value: obj.newValue,
        })
        console.log(obj)
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value)
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        })
    }

	handleClearClick = () => {
		this.setState({
			value: '',
		})
    }
    
    suggestionSelected = (_event, { suggestion }) => {
        this.props.onSelection(suggestion)
    }

    render() {
        const { value, suggestions } = this.state
        const inputProps = {
            placeholder: 'Type Title here...',
            value,
            onChange: this.onChange,
        }

        return (
			<div className="row">
                <div className="block1">
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={
                            this.onSuggestionsFetchRequested
                        }
                        onSuggestionsClearRequested={
                            this.onSuggestionsClearRequested
                        }
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        inputProps={inputProps}
                        onSuggestionSelected={this.suggestionSelected}
                    />
                </div>
				{
                    value.length > 2 ?
                        <div className="block2">
                            <span
                                className="close-icon"
                                onClick={this.handleClearClick}
                            >
                                x
                            </span>
                        </div>
						:
						null
				}
			</div>
		)
    }
}

TitleSelector.propTypes = {
    onSelection: PropTypes.func.isRequired,
}

export default TitleSelector
